import { Box, Grid, Paper, Rating, Typography } from "@mui/material";
import React from "react";
import adImage from '../../images/adImage.png'

const CandidateCoachServiceReviewCard = () => {
    return (
        <>
            <Paper sx={{ mt: 3 }}>
                <Grid container spacing={1} sx={{ p: 1, pb:2 }}>
                    <Grid item xs={3}>
                        <img src={adImage} alt="" className="review-card-image" />
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>
                            <span className="text1Bold">Navdeep | </span>
                            <span className="text1Bold">Lorem ipsum</span>
                            <Rating
                                defaultValue={4}
                                precision={0.5}
                                readOnly
                                className="text1Bold"
                                sx={{ py: 1 }}
                            />
                        </Typography>
                        <Typography className="text2Mid">
                            Lorem ipsum dolor sit amet consectetur. Viverra a porttitor mattis enim tristique donec tristique sapien.
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>
        </>
    );
}

export default CandidateCoachServiceReviewCard;